import { Routes, Route, useNavigate } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import ActivityScreen from "./pages/ActivityScreen/ActivityScreen";
import briefcase from "./assets/HeaderIcons/briefcase.png";
import clock from "./assets/HeaderIcons/clock.png";
import coffee from "./assets/HeaderIcons/coffee.png";
import meditation from "./assets/HeaderIcons/meditation.png";
import pizza from "./assets/HeaderIcons/pizza.png";
import giftbox from "./assets/HeaderIcons/giftbox.png";
import books from "./assets/HeaderIcons/books.png";
import headphones from "./assets/HeaderIcons/headphones.png";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";

import "./App.css";

//Google Analytics tracking
if (!window.gtag) {
  window.gtag = function () {};
}

export default function App() {
  const navigate = useNavigate();

  return (
    <div className="app-main">
      <div className="app-header">
        <div className="app-header-left">
          <img
            src={briefcase}
            alt="I"
            style={{ "--rotate": "-12deg", "--offset": "-16px" }}
          />
          <img
            src={clock}
            alt="I"
            style={{ "--rotate": "25deg", "--offset": "30px" }}
          />
          <img
            src={coffee}
            alt="I"
            style={{ "--rotate": "-26deg", "--offset": "-10px" }}
          />
          <img
            src={meditation}
            alt="I"
            style={{ "--rotate": "10deg", "--offset": "6px" }}
          />
        </div>

        <div className="app-header-center" onClick={() => navigate("/")}>
          <h1 className="breaktime-logo">
            <span className="breaktime-logo-break-part">BREAK</span>
            <span className="breaktime-logo-time-part">
              T<span className="breaktime-logo-i-part">i</span>ME
            </span>
          </h1>
        </div>

        <div className="app-header-right">
          <img
            src={pizza}
            alt="I"
            style={{ "--rotate": "12deg", "--offset": "-6px" }}
          />
          <img
            src={giftbox}
            alt="I"
            style={{ "--rotate": "-20deg", "--offset": "30px" }}
          />
          <img
            src={books}
            alt="I"
            style={{ "--rotate": "25deg", "--offset": "-8px" }}
          />
          <img
            src={headphones}
            alt="I"
            style={{ "--rotate": "-20deg", "--offset": "15px" }}
          />
        </div>
      </div>

      <div className="app-activeScreen">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/activity/:name" element={<ActivityScreen />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </div>
  );
}
